/** The "delete all" icon: two trash cans, so it reads as "delete more
 * than one", distinct from the single can on a per-item delete. Shared by
 * "Delete all Tests" and "Delete all proposed tests" so the two match.
 * Lucide has no multi-trash glyph. */
export function DeleteAllIcon({ className }: { className?: string }) {
  return (
    <svg
      className={className}
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth="1.6"
      strokeLinecap="round"
      strokeLinejoin="round"
      aria-hidden="true"
    >
      {/* back can, peeking behind-left */}
      <path d="M2.5 6.5h6" opacity="0.5" />
      <path d="M3.5 6.5l.55 8.7a1.4 1.4 0 0 0 1.4 1.3h1.1a1.4 1.4 0 0 0 1.4-1.3L8.5 8" opacity="0.5" />
      <path d="M4.8 4.8h1.9a.8.8 0 0 1 .8.8v.9" opacity="0.5" />
      {/* front can */}
      <polyline points="12 6.5 14 6.5 22 6.5" />
      <path d="M20.5 6.5l-.7 11.6a2 2 0 0 1-2 1.9h-3.1a2 2 0 0 1-2-1.9L12 6.5" />
      <path d="M14.7 4.2h2.6a1 1 0 0 1 1 1v1.3" />
      <path d="M15.2 10.5v5.7M18 10.5v5.7" />
    </svg>
  )
}
